import Cookies from 'js-cookie';
import setupTransformerEditor from 'src/utils/setupTransformerEditor';

import LS from './LS';
import setupApiClient from './setupApiClient';
import setupTransformerCompiler from './setupTransformerCompiler';
import { getApiToken } from './tokenProvider';

export const setJwt = (jwt: string): void => {
    LS.set({ jwt });
    Cookies.set('x-jwt', jwt, { expires: 30 });
    setupApiClient(jwt, 'admin-v2-client');
    setupTransformerCompiler();

    // trigger on a delay so that it doesn't slow down initial page load
    // but subsequent navigations to transformer edit aren't slowed down
    // (transform edit page will still immediately trigger initialization
    // if needed)
    void setupTransformerEditorDelayed();
};

const setupTransformerEditorDelayed = async () => {
    await Promise.sleep(2000);
    await setupTransformerEditor();
};

/**
 * Prepares the app for a session whose credential is an Auth0 access token.
 *
 * There is no PI token to store. The api client is handed the token *getter* rather than a string so
 * that a refreshed access token propagates - a string is baked into the axios defaults when the
 * client is first built and would go stale.
 */
export const setupAuth0Session = (): void => {
    LS.set({ authProvider: 'auth0' });
    setupApiClient(getApiToken, 'admin-v2-client');
    setupTransformerCompiler();
    void setupTransformerEditorDelayed();
};

export const clearJwt = (): void => {
    LS.delete('jwt');
    LS.delete('authProvider');
    Cookies.remove('x-jwt');
};
